import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CapacitorHttp, HttpOptions, HttpResponse } from '@capacitor/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class MapboxService {
    /**
     * Constructor
     */
    constructor(private http: HttpClient) {}

    searchCities(term:string, lang:string = 'fr'):Promise<HttpResponse> {
        
        const options:HttpOptions = {
            url: `${environment.mapboxUrl}/mapbox.places/${encodeURI(term)}.json`,
            headers: {  },
            responseType: 'json',
            params: { 
                access_token: environment.mapboxToken,
                autocomplete: 'true',
                language: lang,
                types: 'place',
                proximity: 'ip'
            }
        };
        
        return CapacitorHttp.get(options);
    }

    searchRegions(term:string, lang:string = 'fr'):Promise<HttpResponse> {
        
        const options:HttpOptions = {
            url: `${environment.mapboxUrl}/mapbox.places/${encodeURI(term)}.json`,
            headers: {  },
            responseType: 'json',
            params: { 
                access_token: environment.mapboxToken,
                autocomplete: 'true',
                language: lang,
                types: 'region',
                proximity: 'ip'
            }
        };
        
        return CapacitorHttp.get(options);
    }
}
